import { toast } from "react-toastify";
import { FetchBlockbusterDeal } from "../../Services/MainServices";

export const FETCH_BLOCKBUSTER_REQUEST = "FETCH_BLOCKBUSTER_REQUEST";
export const FETCH_BLOCKBUSTER_SUCCESS = "FETCH_BLOCKBUSTER_SUCCESS";
export const FETCH_BLOCKBUSTER_FAILURE = "FETCH_BLOCKBUSTER_FAILURE";

// Thunk Action
export const getBlockBusterDetails = () => async (dispatch) => {
  dispatch({ type: FETCH_BLOCKBUSTER_REQUEST });

  try {
    const res = await FetchBlockbusterDeal();

    // HTTP + business‑logic check
    if (res?.status === 200 && res?.data?.status === "success") {
      const results = res.data.data?.results || [];
      dispatch({
        type: FETCH_BLOCKBUSTER_SUCCESS,
        payload: results,
      });
    } else {
      const msg = res?.data?.message || "Failed to fetch blockbuster deals";
      dispatch({ type: FETCH_BLOCKBUSTER_FAILURE, payload: msg });
      // toast.error(msg);
    }
  } catch (error) {
    const status = error?.response?.status;

    if (status === 401 || status === 403) {
      // Token expired/unauthorized
      // localStorage.removeItem("access");
      // localStorage.removeItem("refresh");
      toast.error("Session expired. Please login again.");
    } else {
      // toast.error(error?.response?.data?.message || "Something went wrong");
    }

    // dispatch({
    //   type: FETCH_BLOCKBUSTER_FAILURE,
    //   payload: error?.response?.data?.message || error.message || "Something went wrong",
    // });
  }
};
